import { appActions } from "@/store/appSlice";
import { selectBreadcrumbs } from "@/store/appSelectors";
import { Breadcrumb } from "@/lib/types";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

export const useBreadcrumbs = (newCrumbs?: Breadcrumb[]) => {
  const dispatch = useDispatch();
  const breadcrumbs = useSelector(selectBreadcrumbs);

  useEffect(() => {
    const currentCrumbsSerializable = breadcrumbs?.map((crumb) => ({
      name: crumb.name,
      path: crumb.path,
    }));
    const newCrumbsSerializable = newCrumbs?.map((crumb) => ({
      name: crumb.name,
      path: crumb.path,
    }));
    if (JSON.stringify(currentCrumbsSerializable) === JSON.stringify(newCrumbsSerializable)) return;
    if (newCrumbs) {
      dispatch(appActions.setBreadcrumbs(newCrumbs));
      document.title = newCrumbs
        .slice()
        .reverse()
        .map((crumb) => crumb.name)
        .join(" - ");
    }
  }, [newCrumbs, breadcrumbs, dispatch]);

  return { breadcrumbs };
};
